import React, { createContext } from "react";
import MUIDialog from "@mui/material/Dialog";
/**
 * The Frame's `onClose`, published so `Dialog.Header` renders the close button itself — never a
 * public atom, so a call site can't forget or duplicate it, and a Frame without `onClose` renders none.
 */
export const DialogCloseContext = createContext(undefined);
const Frame = ({ size = "sm", isOpen, onClose, className, children, ...rest }) => (React.createElement(MUIDialog, { open: isOpen, onClose: onClose, maxWidth: size, className: className, ...rest },
    React.createElement(DialogCloseContext.Provider, { value: onClose }, children)));
export default Frame;
//# sourceMappingURL=DialogFrame.js.map